module.exports = __webpack_public_path__ + "static/media/view.c93df48b.svg";